import {defineMessages} from 'react-intl';
import {negative} from '@sail/icons/react/Icon';
import {HeaderButton} from '../Header';
import {useWidgetControls, useWidgetVisibility} from '../useWidget';
import {useAnalytics} from '../../AnalyticsProvider';

const messages = defineMessages({
  open: {
    id: 'conversations_ui.widget.header.openButton.label',
    description:
      'Label used for the header button that takes the widget from a minimized state to an open state.',
    defaultMessage: 'Show',
  },
  minimize: {
    id: 'conversations_ui.widget.header.minimizeButton.label',
    description:
      'Label used for the header button that takes the widget from an open state to a minimized state.',
    defaultMessage: 'Hide',
  },
});

type Props = {
  disabled?: boolean;
  color?: string;
  hoverColor?: string;
};

export function DotComMinimizeButton({
  disabled = false,
  color,
  hoverColor,
}: Props) {
  const {visibility} = useWidgetVisibility();
  const {toggle} = useWidgetControls();
  const analytics = useAnalytics();

  const label = visibility === 'open' ? messages.minimize : messages.open;

  return (
    <HeaderButton
      testId="conversations-widget-header-toggle-button"
      icon={negative}
      label={label}
      onPress={() => {
        analytics.action('toggle_minimize_button_clicked');
        toggle();
      }}
      disabled={disabled}
      color={color}
      hoverColor={hoverColor}
      tooltipEnabled={false}
    />
  );
}
